import { useState } from 'react';

import { Button, ButtonsGrid } from 'components/common/button/button';
import { useAppDispatch, useAppSelector } from 'redux/use-hooks';
import { actionAccountSetStorageBalance, selectAccountId } from 'redux/slices/account';
import { actions as statusSliceActions } from 'redux/slices/status';
const { clearLocalAlert, showCustomAlert } = statusSliceActions;

import { actions as tokensSliceActions } from 'redux/slices/tokens';
const { fetchProjects, fetchOwnedTokensForContract } = tokensSliceActions;

import config from 'config';
const { OCC_CONTRACT } = config;

import { fungibleTokensService } from 'services/fungible-tokens';
import { getWalletActionErrorPresentation } from 'utils/wallet';

import {StyledContainer, StyledSection, StyledHeading, StyledHeadingWithOutMargin} from './views.style';

const RetireView = ({
  text = '',
  recipient = '',
  selected,
  callback,
  closeModal
}: {
  text: string;
  recipient: string;
  selected: string[];
  callback: (s?) => void;
  closeModal: () => void;
}) => {
  const dispatch = useAppDispatch();
  const accountId = useAppSelector(selectAccountId);
  const [sendingToken, setSendingToken] = useState(false);

  const onClickHandler = async () => {
    setSendingToken(true);

    try {
      await fungibleTokensService.retire({
        accountId,
        contractName: OCC_CONTRACT,
        selected,
        recipient
      });
      await dispatch(
        fetchProjects({ accountId })
      );
      await dispatch(
        fetchOwnedTokensForContract({
          accountId,
          contractName: OCC_CONTRACT
        })
      );
      dispatch(actionAccountSetStorageBalance({ contractName: OCC_CONTRACT, accountId }));
      setSendingToken(false);
      dispatch(clearLocalAlert());
      callback();
      closeModal();
    } catch (e: any) {
      const presentation = getWalletActionErrorPresentation(e);
      dispatch(
        showCustomAlert({
          showAlert: true,
          success: false,
          messageCodeHeader: 'error',
          messageCode: presentation.messageCode,
          errorMessage: presentation.errorMessage
        })
      );
      setSendingToken(false);
    }
  };

  return (
    <StyledContainer>
      <StyledSection p="40px 58px">
        <StyledHeading mb="16px">
          {`You are about to retire ${text} OCCs, equal to ${text} metric tonnes of carbon. These credits will be retired in the name of ${recipient}.`}
        </StyledHeading>
        <StyledHeadingWithOutMargin mb="16px">
          Are you sure you want to permanently retire these OCCs?
        </StyledHeadingWithOutMargin>
        <ButtonsGrid>
          <Button
            fullwidth
            loading={sendingToken}
            disabled={sendingToken}
            onClick={!sendingToken ? onClickHandler : undefined}
          >
            Yes
          </Button>
          <Button fullwidth variant="secondary" onClick={closeModal}>
            No
          </Button>
        </ButtonsGrid>
      </StyledSection>
    </StyledContainer>
  );
};

export default RetireView;
